import { Alert, Box, CircularProgress, Modal, Snackbar } from "@mui/material";
import { format, parse } from "date-fns";
import { useEffect, useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { ptBR } from "date-fns/locale";
import servSolicitacaoVistoria from "../../../services/login/servSolicitacaoVistoria";
import stylesAgendamento from "./ResultadoAgendamento.module.css"
import { faArrowCircleRight, faCheck, faClose, faPen, faRotate } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ResultadoAgendamento = ({ setOpen, record}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [agendamento, setAgendamento] = useState(null);
    const [situacaoAgendamentoTexto, setSituacaoAgendamentoTexto] = useState("");
    const [situacaoVistoriaTexto, setSituacaoVistoriaTexto] = useState("");
    const [situacaoSolicitacaoVistoriaTexto, setSituacaoSolicitacaoVistoriaTexto] = useState("");

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    useEffect(() => {
        const recuperarAgendamento = async () => {
            try {
                setIsLoading(true);
                let dados = await servSolicitacaoVistoria.RecuperarAgendamento(record?.Id || record?.row?.Id);
                setIsLoading(false);

                formatarValores(dados);
                setAgendamento(dados.Content);
            } catch (err) {
                setIsLoading(false);
                setErrorMessage(err.Message);
                setOpenErrorWindow(true);
            }
        }

        recuperarAgendamento();
    }, []);

    const formatarValores = (dados) => {
        setarSituacaoAgendamentoTexto(dados.Content.Situacao);
        setarSituacaoVistoriaTexto(dados.Content.SituacaoVistoria);
        setarSituacaoSolicitacaoVistoriaTexto(record?.Situacao || record?.row?.Situacao);
    }

    const setarSituacaoAgendamentoTexto = (situacao) => {
        let txtSituacao = "";

        switch (situacao) {
            case 0:
                txtSituacao = "Agendamento não iniciado"
                break;
            case 1:
                txtSituacao = "Agendamento solicitado"
                break;
            case 2:
                txtSituacao = "Agendamento realizado"
                break;
            case 3:
                txtSituacao = "Não gera agendamento"
                break;
            default:
                txtSituacao = "Agendamento não iniciado"
                break;
        }

        setSituacaoAgendamentoTexto(txtSituacao);
    }

    const setarSituacaoVistoriaTexto = (situacao) => {
        let txtSituacao = "";

        switch (situacao) {
            case 1:
                txtSituacao = "Vistoria não iniciada"
                break;
            case 2:
                txtSituacao = "Vistoria em andamento"
                break;
            case 3:
                txtSituacao = "Vistoria aprovada"
                break;
            case 4:
                txtSituacao = "Vistoria reprovada"
                break;
            case 5:
                txtSituacao = "Não gera vistoria"
                break;
            default:
                txtSituacao = "Vistoria não iniciada"
                break;
        }

        setSituacaoVistoriaTexto(txtSituacao);
    }

    const setarSituacaoSolicitacaoVistoriaTexto = (situacao) => {
        let txtSituacao = "";

        switch (situacao) {
            case 0:
                txtSituacao = "Em digitação"
                break;
            case 1:
                txtSituacao = "Aguardando análise"
                break;
            case 2:
                txtSituacao = "Revisar solicitação"
                break;
            case 3:
                txtSituacao = "Agendamento solicitado"
                break;
            case 4:
                txtSituacao = "Vistoria solicitada"
                break;
            case 5:
                txtSituacao = "Concluído"
                break;
            default:
                txtSituacao = "Em digitação"
                break;
        }

        setSituacaoSolicitacaoVistoriaTexto(txtSituacao);
    }

    return (
        <div style={{ width: "100%", minWidth: 600, height: "100%" }}>
            <div className={stylesAgendamento.situacaoAgendamentoOuVistoria}>
                <div className={
                        agendamento?.Situacao === 0
                        ? `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.NaoIniciado}`
                        : agendamento?.Situacao === 1
                        ? `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.AguardandoAnalise}` 
                        : agendamento?.Situacao === 2
                        ? `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.Finalizada}`
                        : `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.NaoGera}`
                }>
                    <h3>Agendamento</h3>
                    <div className={stylesAgendamento.parecerSituacaoAgendamentoOuVistoria}>
                        Situação:  {
                            situacaoAgendamentoTexto
                        }    
                        <p><FontAwesomeIcon 
                            size="lg"
                            icon={
                                agendamento?.Situacao === 0
                                ? faPen
                                : agendamento?.Situacao === 1
                                ? faArrowCircleRight
                                : agendamento?.Situacao === 2
                                ? faCheck
                                : faClose
                            }
                            />
                        </p>
                    </div>
                </div>

                { (agendamento !== null && agendamento?.Id !== 0 && agendamento?.Situacao !== 3) && (
                    <div>
                        <header className={stylesAgendamento.header}>
                            <span className={stylesAgendamento.headerData}>
                                <div className={stylesAgendamento.dateBox}></div><b>Data de solicitação: </b> {
                                    agendamento?.DataSolicitacao?.includes("01/01/1900") ?
                                        "Data ainda não definida" :
                                        format(parse(agendamento?.DataSolicitacao, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                            locale: ptBR
                                        })
                                }
                            </span>
                        </header>

                        <header className={stylesAgendamento.header}>
                            <span className={stylesAgendamento.headerData}>
                                <div className={`${stylesAgendamento.dateBox} ${stylesAgendamento['dateBox-darkblue']}`}></div><b>Data de agendamento: </b> {
                                    agendamento?.DataAgendamento?.includes("01/01/1900") ?
                                        "Data ainda não definida" :
                                        format(parse(agendamento?.DataAgendamento, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                            locale: ptBR
                                        })
                                }
                            </span>
                        </header>
                    </div>
                ) }

                <hr></hr>

                <div className={
                        agendamento?.SituacaoVistoria === 1
                        ? `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.NaoIniciado}`
                        : agendamento?.SituacaoVistoria === 2 
                        ? `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.AguardandoAnalise}` 
                        : agendamento?.SituacaoVistoria === 3
                        ? `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.Finalizada}`
                        : agendamento?.SituacaoVistoria === 4 
                        ? `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.Reprovada}`
                        : `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.NaoGera}`
                }>
                    <h3>Vistoria</h3>
                    <div className={stylesAgendamento.parecerSituacaoAgendamentoOuVistoria}>
                        Situação:  {
                            situacaoVistoriaTexto
                        }    
                        <p><FontAwesomeIcon 
                            size="lg"
                            icon={
                                agendamento?.SituacaoVistoria === 1
                                ? faPen
                                : agendamento?.SituacaoVistoria === 2 
                                ? faArrowCircleRight
                                : agendamento?.SituacaoVistoria === 3
                                ? faCheck
                                : faClose
                            }
                            />
                        </p>
                    </div>
                </div>

                { (agendamento !== null && agendamento?.Id !== 0 && agendamento?.SituacaoVistoria !== 5) && (
                    <div>
                        <header className={stylesAgendamento.header}>
                            <span className={stylesAgendamento.headerData}>
                                <div className={`${stylesAgendamento.dateBox} ${stylesAgendamento['dateBox-purple']}`}></div><b>Data de resultado da vistoria: </b> {
                                    agendamento?.DataResultadoVistoriaUC?.includes("01/01/1900") ?
                                        "Data ainda não definida" :
                                        format(parse(agendamento?.DataResultadoVistoriaUC, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                            locale: ptBR
                                        }) 
                                }
                            </span>
                        </header>
                    </div>
                ) }

                <hr></hr>

                <div className={
                        (record?.Situacao || record?.row?.Situacao) === 0
                        ? `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.NaoIniciado}`
                        : (record?.Situacao || record?.row?.Situacao) === 1 
                        ? `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.AguardandoAnalise}` 
                        : (record?.Situacao || record?.row?.Situacao) === 2
                        ? `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.EmRevisao}`
                        : (record?.Situacao || record?.row?.Situacao) === 3 
                        ? `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.Solicitado}`
                        : (record?.Situacao || record?.row?.Situacao) === 4
                        ? `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.Solicitado}`
                        : `${stylesAgendamento.resultadoAgendamentoOuVistoriaParcial} + ${stylesAgendamento.Finalizada}`
                }>
                    <h3>Resultado geral</h3>
                    <div className={stylesAgendamento.parecerSituacaoAgendamentoOuVistoria}>
                        {
                            situacaoSolicitacaoVistoriaTexto
                        }    
                        <p><FontAwesomeIcon 
                            size="lg"
                            icon={
                                (record?.Situacao || record?.row?.Situacao) === 0
                                ? faPen
                                : (record?.Situacao || record?.row?.Situacao) === 1
                                ? faRotate
                                : (record?.Situacao || record?.row?.Situacao) === 2
                                ? faRotate
                                : (record?.Situacao || record?.row?.Situacao) === 3
                                ? faArrowCircleRight
                                : (record?.Situacao || record?.row?.Situacao) === 4
                                ? faArrowCircleRight
                                : faCheck
                            }
                            />
                        </p>
                    </div>
                </div>
            </div>

            <div style={{
                margin: "25px 40px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px"
            }}>
                <BlueHoverButton onClick={() => setOpen(false)}>Fechar</BlueHoverButton>
            </div>

            <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    )
}

export { ResultadoAgendamento }